import {saveUserRegistrySettings} from "../api/registrySettings";
import {setIncidentManagerSettings} from "../config/localStorage";
import {
  INCIDENT_FILTER_SORT_DEFAULT,
  INCIDENT_FILTER_SORT_OPTIONS
} from "./options";

export const UISettingsKeyForIncidentManager = "ctrUI_IncidentManagerSettings";

export const updateIncidentManagerSettings = (settings) => {
  saveUserRegistrySettings(UISettingsKeyForIncidentManager, settings);
  setIncidentManagerSettings(settings);
};

/**
 * Handles keys and values that no longer exist in filter/sort, but are still
 * saved in the users settings
 *
 * @param {Object} settings user settings
 * @returns {Object} user settings without removed options
 */
export const handleRemovedFilterSortOptions = (settings) => {
  const allowedSettingKeys = Object.keys(INCIDENT_FILTER_SORT_DEFAULT);
  const keysWithOptions = Object.keys(INCIDENT_FILTER_SORT_OPTIONS);

  if (settings && settings !== null) {
    // Removes old setting keys that no longer exist
    const filteredSettings = Object.keys(settings).filter((key) =>
      allowedSettingKeys.includes(key)
    );

    // Handles options saved in settings that no longer exist
    const settingValues = filteredSettings.reduce((acc, key) => {
      const hasOptions = keysWithOptions.includes(key);
      const isDateSetting = key === "dateRangeFilter";
      const settingKeyValue = isDateSetting
        ? settings[key].filter
        : settings[key];

      if (hasOptions) {
        const existingOptions = isDateSetting
          ? Object.values(INCIDENT_FILTER_SORT_OPTIONS[key]).map((v) => v.value)
          : Object.keys(INCIDENT_FILTER_SORT_OPTIONS[key]);

        if (Array.isArray(settings[key])) {
          // Filters out removed options from settings with array values
          settings[key] = settings[key].filter((val) =>
            existingOptions.includes(val)
          );
        } else {
          // Replaces removed options with default option values
          settings[key] = existingOptions.includes(settingKeyValue)
            ? settings[key]
            : INCIDENT_FILTER_SORT_DEFAULT[key];
        }
      }
      acc[key] = settings[key];

      return acc;
    }, {});

    return settingValues;
  } else {
    /**
     * Allow settings to return null from localStorage. Necessary to determine
     * if we need to pull from user settngs.
     */
    return settings;
  }
};
